import SearchSummary from './SearchSummary';

export default SearchSummary;
